import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton,
  FDTextInput,
  FDStack,
  FDDialogTitle,
  FDDialogContent,
  FDDialogActions,
  FDDialog,
  FDBox, FDTextButton,
} from '@facet-wealth/design';
import { validateFolderName } from './validate';

class FolderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      folderName: '',
      isAPIRequestPending: false,
    };
    this.handleCreateFolder = this.handleCreateFolder.bind(this);
    this.handleFolderNameChange = this.handleFolderNameChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { closeModal } = this.props;
    this.setState({ folderName: '' });
    closeModal();
  }

  handleCreateFolder() {
    const {
      closeModal,
      createFolder,
      folderID,
      folderName: folderNameProp,
      refreshFolder,
      householdId,
    } = this.props;
    const { folderName } = this.state;
    const onSuccess = () => {
      closeModal();
      this.setState({ isAPIRequestPending: false, folderName: '' });
    };
    const onFail = onSuccess;
    this.setState({ isAPIRequestPending: true });
    createFolder({
      type: 'folder',
      attributes: {
        name: folderName,
        parentFolderID: folderID,
      },
    }, {
      householdId: householdId.toString(),
    })
      .then(() => {
        refreshFolder(folderID, folderNameProp, onSuccess, onFail);
      })
      .catch(() => {
        onFail();
      }); // TODO: display an alert message
  }

  handleFolderNameChange(e) {
    const val = e.target.value;
    this.setState({ folderName: val });
  }

  render() {
    const { isOpen } = this.props;
    const { folderName, isAPIRequestPending } = this.state;
    const validFolderName = validateFolderName(folderName);

    return (
      <FDDialog
        onClose={this.handleClose}
        open={isOpen}
      >
        <FDDialogTitle value={'Create Folder'} />
        <FDDialogContent>
          <FDBox width={'500px'}>
            <FDStack
              direction="column"
              spacing={2}
            >
              <FDTextInput
                label={'Folder Name'}
                test={'foldername'}
                placeholder={'Folder Name'}
                value={folderName}
                onChange={this.handleFolderNameChange}
                error={folderName !== '' && !validFolderName}
                helperText={folderName !== '' && !validFolderName ? 'Invalid folder name' : ''}
              />
            </FDStack>
          </FDBox>
        </FDDialogContent>
        <FDDialogActions>
          <FDPrimaryActionButton
            label={'Save'}
            loading={isAPIRequestPending}
            onClick={this.handleCreateFolder}
            disabled={!validFolderName || isAPIRequestPending}
            test="save"
          />
          <FDTextButton
            label={'Cancel'}
            onClick={this.handleClose}
            test="close"
          />
        </FDDialogActions>
      </FDDialog>
    );
  }
}
FolderModal.propTypes = {
  createFolder: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  folderID: PropTypes.number.isRequired,
  folderName: PropTypes.string.isRequired,
  refreshFolder: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
};

export default FolderModal;
